<template>
  <section class="exploreSection">
    <h1 class="exploreTitle">Explore new African stories</h1>
    <div v-if="featuredPodcasts.length > 0" class="carouselContainer">
      <div class="phoneFrame">
        <img
          alt="A phone showing a podcast player interface"
          height="671"
          src="/static/images/home/phone-frame.webp"
          width="324"
        />
      </div>
      <div class="phoneBackground" />
      <span class="datasetTitleTarget">{{ slideTitle }}</span>
      <span class="datasetArtistTarget">{{ slideArtist }}</span>
      <KeenSlider
        :arrows="false"
        :auto-switch="true"
        :dots="false"
        :drag="true"
        :slides-per-view-desktop="4.5"
        :slides-per-view-mobile="1.7"
        :slides-per-view-small-mobile="1.5"
        :slides-per-view-tablet="3"
        :slides-per-view-ultra-wide="5.5"
        class="podcastsSlider"
        @onSlideDataUpdated="onHandleSlideDataUpdated"
      >
        <div v-for="(podcast, index) in featuredPodcasts" :key="podcast.id">
          <div
            :key="key"
            :data-artist="podcast.author.name"
            :data-title="podcast.title"
            class="keen-slider__slide slideSlot"
          >
            <img
              :key="index"
              :alt="podcast.title"
              :src="imagePath(podcast.images.main)"
              class="sliderImage"
              height="390"
              width="390"
            />
          </div>
        </div>
      </KeenSlider>
    </div>
    <RouterLink :to="{ name: 'Listen' }" class="btn-round-white ctaButton">Listen now</RouterLink>
  </section>
</template>

<script setup>
import { getCurrentInstance, onMounted, ref } from 'vue'

import KeenSlider from 'components/reused-components/keenSlider/KeenSlider'
import config from 'conf'

const { $http: http, $log: log } = getCurrentInstance().proxy

const slideTitle = ref('')
const slideArtist = ref('')
const featuredPodcasts = ref([])

const onHandleSlideDataUpdated = ({ artist, title }) => {
  slideTitle.value = title
  slideArtist.value = artist
}

const imagePath = (file) => config.image.podcast.main + file

const fetchFeaturedPodcasts = async () => {
  try {
    const response = await http.get(`${config.url.podcasts}/featured`)
    const featuredPodcastsList = response.body.data ?? []

    return featuredPodcastsList.slice(0, 14)
  } catch (error) {
    log.error(error)

    return []
  }
}

onMounted(async () => {
  featuredPodcasts.value = await fetchFeaturedPodcasts()
})
</script>

<style lang="scss" scoped>
@import 'assets/scss/base/bootstrap_variables';
@import 'assets/scss/base/functions';

.exploreSection {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  margin-top: 88px;

  @media (min-width: $screen-sm-min) {
    margin-top: 120px;
  }

  .exploreTitle {
    font-size: to-rem(34);
    font-weight: 400;
    line-height: 1.1;
    color: inherit;
    text-align: center;

    @media (min-width: $screen-sm-min) {
      font-size: to-rem(52);
    }
  }

  .carouselContainer {
    position: relative;
    width: 100vw;
    margin-top: 56px;
    user-select: none;

    .phoneFrame {
      position: absolute;
      top: -5px;
      left: 50%;
      z-index: 20;
      width: 324px;
      pointer-events: none;
      transform: translate(-50%, 0);

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        pointer-events: none;
      }
    }

    .phoneBackground {
      position: absolute;
      top: 97px;
      left: 50%;
      z-index: 5;
      width: 220px;
      height: 220px;
      pointer-events: none;
      background-color: #1d1f24;
      transform: translate(-50%, 0);
    }

    .podcastsSlider {
      margin-top: 109px;

      .slideSlot {
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;

        .sliderImage {
          width: 195px;
          height: 195px;
          overflow: hidden;
          border-radius: 12px;
          box-shadow: 0 16px 40px rgb(0 0 0 / 40%);
          object-fit: cover;
        }
      }

      :deep(.keen-slider),
      .keen-slider__slide {
        overflow: visible; // so the box-shadow is visible
      }
    }

    .datasetTitleTarget {
      position: absolute;
      top: 340px;
      left: 50%;
      z-index: 25;
      font-size: to-rem(15);
      color: $color-white;
      white-space: pre;
      transform: translate(-50%, 0);

      @media (min-width: $screen-sm-min) {
        font-size: to-rem(17);
      }
    }

    .datasetArtistTarget {
      position: absolute;
      top: 318px;
      left: 50%;
      z-index: 25;
      font-size: to-rem(12);
      color: $brand-danger;
      white-space: pre;
      transform: translate(-50%, 0);

      @media (min-width: $screen-sm-min) {
        font-size: to-rem(14);
      }
    }
  }

  .ctaButton {
    margin-top: 402px;
  }
}
</style>



// WEBPACK FOOTER //
// ExploreSection.vue